import React, { Component } from 'react';
import { connect } from 'react-redux';

import CustomBraintreeDropin from './CustomBraintreeDropin.jsx';
import { placePreorder } from '../modules/order_actions';

import {priceOneItemCart}    from '../shared/cart.js';

class PreorderPurchase extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isConfirmOpen: false,
      isConfirmCreditOpen: false
    };
    this.toggleConfirmState  = this.toggleConfirmState.bind(this);
    this.toggleConfirmCreditState = this.toggleConfirmCreditState.bind(this);
    this.updatePricing = this.updatePricing.bind(this);

    this.updatePricing(this.props);
  }

  componentWillReceiveProps(nextProps){
    if(this.props.productType !== nextProps.productType) this.updatePricing(nextProps);
  }

  updatePricing(self){
    this.creditAdditionalParams = {
      mmid: self.productType === "regular" ? (this.props.product.mmid || null) : (this.props.product[self.productType].mmid || null),
      format: self.productType,
      credit: 1
    };
    this.additionalParams = {
      mmid: self.productType === "regular" ? (this.props.product.mmid || null) : (this.props.product[self.productType].mmid || null),
      format: self.productType,
      credit: 0
    };

     try {
      // Preorder books are 17.99
      // Shipping is 2.99 for preorders
      // For HBC and TGC (non-bundle clubs), preorder price is the same as the book's sale price
      let bookPrice      =  self.productType !== "regular" ? this.props.product[self.productType].price : this.props.product.sale_price;
      let priceObj       = priceOneItemCart(bookPrice, 0, this.props.customer);
      let creditPriceObj = priceOneItemCart(bookPrice, 1, this.props.customer);

      this.sPreorderPrice     = '$' + bookPrice.toFixed(2);
      this.shipping           = '$' + priceObj.shipping.toFixed(2);
      this.sPreorderTax        = '$' + priceObj.tax.toFixed(2);
      this.sPreorderCreditTax  = "$" + creditPriceObj.tax.toFixed(2);
      this.sPreorderTotal     = '$' + ( bookPrice + (priceObj.tax) + priceObj.shipping ).toFixed(2);
      this.sPreorderCreditTotal = '$' + ( creditPriceObj.tax + creditPriceObj.shipping ).toFixed(2);
    }  catch(e){
      console.error("problems generating book price, tax and shipping");
      console.error(e);

    }
  }

  toggleConfirmState() {
    this.setState({isConfirmOpen: !this.state.isConfirmOpen});
    if( !this.state.isConfirmOpen) {
      if( this.state.isConfirmCreditOpen === true) this.toggleConfirmCreditState();
    }
  }

  toggleConfirmCreditState() {
    this.setState({isConfirmCreditOpen: !this.state.isConfirmCreditOpen});
    if( !this.state.isConfirmCreditOpen) {
      if( this.state.isConfirmOpen === true) this.toggleConfirmState();
    }
  }

  render() {
    let {product, toggleFormat, isLoggedIn, upgradeStatus, customer, availableForBundle, productType, preorderMessage} = this.props;
    if (!customer.cart) {
      let sDate = new Date(product.available_date).toDateString().slice(4);
      return (
        <div className="message-box"></div>
      );
    }
    let formatButton = <div />;
    let oShowPreorderCreditPurchase = '';
    let oShowPreorderPurchase = '';
    let spacingClass          = '';
    let oShowPreorder         = ( customer.status === "Active" && isLoggedIn && !upgradeStatus);
    let oPreorderPurchased    = customer.order_history.find( x => x.items.find( x => x.mmid === product.mmid )) ||
      (productType !== 'regular' && customer.order_history.find( x => x.items.find( x => x.mmid === product[productType].mmid ))) ;
    let sPreorderMsgClass    = ((preorderMessage.type === 'error') ? 'errorMessage ' : 'successMessage ') + 'showing';
    let ePreorderMessage     = preorderMessage && preorderMessage.text ? (
      <div className={sPreorderMsgClass}>
        <p>{preorderMessage.text}</p>
      </div>
      ) : '';

    if(product.large_print ){
      spacingClass = " extra-space";
      formatButton = (
        <div className="formatContainer">
          <div className={ "format button" + (productType === "regular" ? " active" : "")} onClick={() => toggleFormat("regular")}>
            Regular Print
          </div>
          <div className={ "format button" + (productType === "large_print" ? " active" : "")} onClick={() => toggleFormat("large_print")}>
            Large Print
          </div>
        </div>
      );
    }
    else if(product.bluray ){
      spacingClass = " extra-space";
      formatButton = (
        <div className="formatContainer">
          <div className={ "format button" + (productType === "regular" ? " active" : "")} onClick={() => toggleFormat("regular")}>
            DVD
          </div>
          <div className={ "format button" + (productType === "bluray" ? " active" : "")} onClick={() => toggleFormat("bluray")}>
            Blu-ray
          </div>
        </div>
      );
    }

    if(oPreorderPurchased){
      oShowPreorderPurchase = (
        <div>
          <div className="message-box showing preorder-success">
            <div>
              <h4 className="alt2">You pre-ordered this title on {oPreorderPurchased.created_at}</h4>
            </div>
          </div>
        </div>
      );
    } else if(oShowPreorder){
        if(customer.credit_total > 0){

          if(!this.state.isConfirmCreditOpen) {
            oShowPreorderCreditPurchase = (
              <div>
                <button
                  className={"btn-secondary" + (this.state.isConfirmCreditOpen ? " hidden" : "")}
                  name="buy-ebook"
                  onClick={this.toggleConfirmCreditState}
                >
                  Pre-order for 1 Credit
                </button>
              </div>
              );
          } else {
              oShowPreorderCreditPurchase = (
                <div className={"message-box preorder-purchase" + (this.state.isConfirmCreditOpen ? " showing" : "") + spacingClass}>
                  <div>
                    <h6>Pre-order for 1 Credit</h6>
                    <h7 className="alt">Order this title today by simply clicking on the "PLACE ORDER" button below. This title is not eligible to add to your box until {availableForBundle}.</h7>

                    <CustomBraintreeDropin
                      submitFunction = {placePreorder}
                      additionalParams = {this.creditAdditionalParams}
                      uniqueContainer = "preorder-credit-form" />
                    <div className ="neg-margin">

                      <div className="half-col left">
                        <h7 className="alt">Subtotal</h7>
                        <h7 className="alt">Shipping</h7>
                        <h7 className="alt">Tax</h7>
                        <h7 className="strong alt"><strong>Total</strong></h7>
                      </div>
                      <div className="half-col right">
                        <h7 className="alt">$0.00</h7>
                        <h7 className="alt">{this.shipping}</h7>
                        <h7 className="alt">{this.sPreorderCreditTax}</h7>
                        <h7 className="strong alt"><strong>{this.sPreorderCreditTotal}</strong></h7>
                      </div>
                    </div>
                    {formatButton}
                  </div>
                </div>
              );
          }

        }

        if(!this.state.isConfirmOpen){
          oShowPreorderPurchase = (
            <div>
              <button
                className={"btn-primary" + (this.state.isConfirmOpen ? " hidden" : "")}
                name="buy-ebook"
                onClick={this.toggleConfirmState}
              >
                Pre-order for {this.sPreorderPrice}
              </button>
            </div>
          );
        } else {
          oShowPreorderPurchase = (
              <div className={"message-box preorder-purchase" + (this.state.isConfirmOpen ? " showing" : "") + spacingClass}>
                <div>
                  <h6>Preorder for {this.sPreorderPrice}</h6>
                  <h7 className="alt">Order this title today by simply clicking on the "PLACE ORDER" button below. This title is not eligible to add to your box until {availableForBundle}.</h7>

                  <CustomBraintreeDropin
                    submitFunction = {placePreorder}
                    additionalParams = {this.additionalParams}
                    uniqueContainer = "preorder-form" />
                  <div className ="neg-margin">

                    <div className="half-col left">
                      <h7 className="alt">Subtotal</h7>
                      <h7 className="alt">Shipping</h7>
                      <h7 className="alt">Tax</h7>
                      <h7 className="strong alt"><strong>Total</strong></h7>
                    </div>
                    <div className="half-col right">
                      <h7 className="alt">{this.sPreorderPrice}</h7>
                      <h7 className="alt">{this.shipping}</h7>
                      <h7 className="alt">{this.sPreorderTax}</h7>
                      <h7 className="alt"><strong>{this.sPreorderTotal}</strong></h7>
                    </div>
                  </div>
                  {formatButton}
                </div>
              </div>
          );
      }

    }

    return (
      <div>
        {ePreorderMessage}
        {oShowPreorderPurchase}
        {oShowPreorderCreditPurchase}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'preorder_price': state.store.preorder_price,
      'customer': state.customer,
      'isLoggedIn': state.isLoggedIn,
      'preorderMessage': state.preorderMessage,
      'upgradeStatus': state.upgradeStatus
    };
}

export default connect(mapStateToProps)(PreorderPurchase);



// WEBPACK FOOTER //
// ./src/components/PreorderPurchase.jsx